import { IGetConfigurarPagamentoColetaPrecoUseCase } from "../../../presentation/useCases/read/get_configurar_pagamento_coleta_preco_use_case";
import { ConfigurarPagamentoColeta } from "../../models/configurar_pagamento_coleta";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetConfigurarPagamentoColetaPrecoUseCase
 */

export class GetConfigurarPagamentoColetaPrecoUseCase implements IGetConfigurarPagamentoColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getConfigurarPagamentoColetaPreco(
    idColetaPreco: number | undefined,
  ): Promise<ConfigurarPagamentoColeta | null> {
    if (idColetaPreco === undefined) throw new Error('Falha ao obter id de coleta de preço!');
    return await this.repository.getConfigurarPagamentoColetaPreco(
      idColetaPreco,
    );
  }
}
